import React from 'react'

import { MapContext } from './MapContext'

export function useMap() {
  const mapModel = React.useContext(MapContext)

  if (!mapModel) {
    throw new Error('Render MapProvider before accessing MapModel')
  }

  return mapModel
}
